import { useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { DayPicker } from "react-day-picker";
import { format } from "date-fns";
import "react-day-picker/dist/style.css";

function Partner() {
  const [selectedDate, setSelectedDate] = useState();
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("Selected file:", file);
  };

  return (
    <div className="flex flex-col px-5 mt-20 mb-20" dir="rtl">
      {/* Header Section */}
      <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
        كن شريكًا
      </div>
      <div className="mt-5 w-full text-lg text-right text-zinc-900 max-md:max-w-full leading-8">
        "ندعو المنظمات والمؤسسات إلى الانضمام إلى مؤسسة الخير كشريك في تحقيق
        التأثير الإيجابي وتقديم الدعم للمحتاجين في مجتمعاتنا. معًا، يمكننا صنع
        فرق حقيقي وبناء عالم أفضل للجميع."
      </div>

      <div className="mt-11 w-full max-md:mt-10 max-md:max-w-full">
        <div className="flex gap-10 max-md:flex-col">
          
          {/* Main Form Section */}
          <div className="flex flex-col w-[60%] max-md:w-full">
            <div className="flex flex-col grow py-8 px-10 bg-white rounded-xl border border-solid border-neutral-200 shadow-sm max-md:px-5">
              <div className="text-2xl font-bold text-right text-black mb-2">
                انضم معنا ك شريك
              </div>
              <div className="font-light text-right text-neutral-500 mb-10 leading-6">
                وفقًا لإرشادات لجنة المؤسسات الخيرية في المملكة المتحدة المتعلقة
                بالشراكات، نحتاج إلى معرفة المزيد عن مؤسستك والتفاصيل المقترحة
                للشراكة.
              </div>

              {/* Form Fields */}
              <div className="space-y-6 text-right">
                <div>
                  <label className="block text-base font-medium text-slate-700 mb-1.5">إسم المؤسسة</label>
                  <input
                    className="w-full px-4 py-3 text-sm text-gray-700 bg-white rounded-lg border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="يرجى كتابة اسم المؤسسة هنا"
                  />
                </div>

                <div>
                  <label className="block text-base font-medium text-slate-700 mb-1.5">تصنيف المؤسسة</label>
                  <div className="relative flex items-center px-4 py-3 bg-white rounded-lg border border-gray-300 shadow-sm">
                    <LazyLoadImage
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/4cd540013278e9508615c87f31c47d39b444cd1d16eae81e9a9b36845244e08e?"
                      className="w-5 h-5 ml-3"
                    />
                    <select className="w-full bg-transparent text-sm text-gray-500 outline-none appearance-none">
                      <option>يرجى اختيار تصنيف المؤسسة</option>
                      <option>خيرية</option>
                      <option>حكومية</option>
                      <option>خاصة</option>
                    </select>
                  </div>
                </div>

                {/* Date Picker Section */}
                <div>
                  <label className="block text-base font-medium text-slate-700 mb-1.5">تاريخ التأسيس</label>
                  <div className="relative">
                    <div
                      onClick={() => setIsPickerOpen(!isPickerOpen)}
                      className="flex items-center px-4 py-3 bg-white rounded-lg border border-gray-300 shadow-sm cursor-pointer"
                    >
                      <LazyLoadImage
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/df5656ebae8aa022ae286701f85266fa2823893048ffd1f80c594360155af511?"
                        className="w-5 h-5 ml-3"
                      />
                      <span className={`text-sm ${selectedDate ? "text-zinc-900" : "text-gray-400"}`}>
                        {selectedDate ? format(selectedDate, "dd/MM/yyyy") : "DD/MM/YYYY"}
                      </span>
                    </div>

                    {isPickerOpen && (
                      <div className="absolute z-50 mt-2 bg-white border rounded-lg shadow-2xl p-2 top-full right-0">
                        <DayPicker
                          mode="single"
                          selected={selectedDate}
                          onSelect={(date) => {
                            setSelectedDate(date);
                            setIsPickerOpen(false);
                          }}
                          dir="rtl"
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <label className="block text-base font-medium text-slate-700 mb-1.5">رقم الهاتف</label>
                  <div className="flex items-center px-4 py-3 bg-white rounded-lg border border-gray-300 shadow-sm">
                    <LazyLoadImage
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/aa1062db4026b3413a62e8fcf071bee60d5880948733f8e245fddcc25f655dfe?"
                      className="w-5 h-5 ml-3"
                    />
                    <input className="w-full text-sm outline-none" placeholder="000 000 000" />
                  </div>
                </div>

                <div>
                  <label className="block text-base font-medium text-slate-700 mb-1.5">العنوان الكامل</label>
                  <textarea
                    className="w-full px-4 py-3 text-sm bg-white rounded-lg border border-gray-300 shadow-sm h-24 resize-none outline-none"
                    placeholder="اكتب العنوان هنا"
                  />
                </div>

                {/* File Upload Area */}
                <div>
                  <label className="block text-base font-medium text-slate-700 mb-1.5">الأوراق الثبوتية</label>
                  <div
                    onClick={handleClick}
                    className="flex flex-col items-center justify-center py-10 rounded-lg border-2 border-dashed bg-slate-50 border-slate-300 cursor-pointer hover:bg-slate-100 transition-colors"
                  >
                    <div className="flex gap-2 items-center text-sm font-bold text-gray-500">
                      <span>اضغط لرفع الملف</span>
                      <LazyLoadImage
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/f1fd7e53dd4f5bd51bed1aef7945553f511f9e9e3af173d694babe99a6342704?"
                        className="w-6 h-6"
                      />
                    </div>
                    <input type="file" ref={fileInputRef} onChange={handleFileChange} className="hidden" />
                  </div>
                </div>

                <div className="flex items-center gap-3 pt-4">
                  <input type="checkbox" className="w-5 h-5 accent-blue-600 rounded cursor-pointer" id="terms" />
                  <label htmlFor="terms" className="text-sm text-slate-700 cursor-pointer">الموافقة على صحة البيانات المقدمة</label>
                </div>
              </div>

              <button className="w-full py-4 mt-10 text-base font-bold text-white bg-blue-600 rounded-lg shadow-lg hover:bg-blue-700 active:scale-[0.98] transition-all">
                ارسال الطلب
              </button>
            </div>
          </div>

          {/* Sidebar Section */}
          <div className="flex flex-col w-[40%] max-md:w-full space-y-6">
            <LazyLoadImage
              src="https://s3-alpha-sig.figma.com/img/8ff5/4186/3b94b4acd95a9ee9917430e7bb8d2ef0?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=YeaLtXRQq5bzmXiGFd9~xu9X89KyckHAnwGl87X8vl7t5dCXCT-NVE4M7X0ta7fQQ7SRSLcIK6uSViIyNU2MKDG1Iiqzv9oXmPjl4reZ4bXzKKCFlJUoWipHnLMzUekLAPUmeKP8zW4hfKjOcZoD9Rakd6O8OMLxNfF2dk33yg4cjncE7PurFM9jWy63v3i5yI4yLfzFL3AUqp-byvPiiiCdA~RMrGSkIw7VF990HoojB03hWl1klCuC4o8XtZeSYd4EB3XIqE7GutgwrNTtE04S24l1nE6wO3hJWaKwrPwomLcoXJHalBprq1p0nBQrSWNJtOMPPwZuoUArSArYuQ__"
              className="w-full rounded-2xl shadow-md aspect-[0.9] object-cover"
            />

            {/* Social Links */}
            <div className="p-8 bg-zinc-50 border border-zinc-200 rounded-2xl backdrop-blur-md">
              <div className="text-xl font-bold text-black mb-6">حساباتنا على الشبكات الاجتماعية</div>
              <div className="grid grid-cols-6 gap-4">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                  <div key={i} className="hover:scale-110 transition-transform cursor-pointer">
                    <LazyLoadImage src={`https://cdn.builder.io/api/v1/image/assets/TEMP/social-${i}?`} className="w-9 h-9" />
                  </div>
                ))}
              </div>
            </div>

            {/* Whatsapp Contact */}
            <div className="p-8 bg-zinc-50 border border-zinc-200 rounded-2xl flex justify-between items-center group cursor-pointer hover:bg-white transition-colors">
              <div>
                <div className="text-sm font-medium text-gray-500">تواصل معنا عبر</div>
                <div className="text-4xl font-black text-green-600">Whatsapp</div>
              </div>
              <LazyLoadImage
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/03ffb6bfa8845e1ece927c7f3ed04ec7434a9085b1a1f534a0a4314f9aebbd32?"
                className="w-16 h-16 group-hover:rotate-12 transition-transform"
              />
            </div>

            {/* Email Contact */}
            <div className="p-8 bg-zinc-50 border border-zinc-200 rounded-2xl">
              <div className="flex items-center gap-3 mb-4">
                <LazyLoadImage src="https://cdn.builder.io/api/v1/image/assets/TEMP/97da42ebd1c32fc1370bd5210b018037f7ee9fd125c3215f0067fafefbc09cee?" className="w-8 h-8" />
                <div className="text-xl font-bold text-black">البريد الالكتروني؟</div>
              </div>
              <div className="text-gray-600 leading-7">
                أرسل لنا رسالة على{" "}
                <a href="mailto:info@alkhairmiddleeast.org" className="text-blue-600 font-bold underline hover:text-blue-800">
                  info@alkhairmiddleeast.org
                </a>
                <br />
                أو استخدم نموذج الاتصال الموجود على اليمين!
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Partner;
